<template>
  <div>
    <el-select @focus="focus"
               filterable
               remote
               :remote-method="remoteMethod"
               v-model="selectvalue" size="mini" :placeholder="pleasett" value-key="_id"
               clearable @change="selectdata">
      <el-option v-for="(item, index) in selectlist_datas" :value="{ _id: item._id, name: item[temp.field.key] }"
                 :label="item[temp.field.key]" :key="index">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import util from "../../../assets/js/util";

export default {
  props: ["temp", "field"],
  name: "dataselect",
  data() {
    return {
      pleasett: '请选择' + this.temp.field.name || '请选择',
      selectvalue: {},
      selectlist_datas: [],
      query: {},
      selectlaststatus: false
    }
  },
  async mounted() {
    this.selectvalue = this.temp.value
    setTimeout(() => {
      if (this.temp.value && this.temp.value._id) {
        this.pleasett = this.temp.value.name
      }
    })
    // this.focus()
  },
  methods: {
    async remoteMethod(e) {
      console.log(1)
      if (this.temp.condition_me && JSON.stringify(this.temp.condition_me) != "{}") { //条件查询
        var value = {}
        for (var i = 0; i < this.field.length; i ++) {
          if (this.field[i].key == this.temp.condition_me.key) {

            if (!this.field[i].value && !this.field[i].value._id && this.selectlist_datas.length > 0) {
              util.error("请先选择" + this.field[i].name)
              this.selectlist_datas = []
              this.selectvalue = {}
            } else {
              value = this.field[i].value
            }
          }
        }

      }

      this.query[this.temp.field.key] = e
      this.focus()

    },
    async focus(key, value) {
      var select = []
      //条件

      if (this.temp.condition_me && JSON.stringify(this.temp.condition_me) != "{}") { //条件查询
        var value = {}
        for (var i = 0; i < this.field.length; i ++) {

          if (this.field[i].key == this.temp.condition_me.key) {
            if (!this.field[i].value && !this.field[i].value._id && this.selectlist_datas.length == 0) {
              util.error("请先选择" + this.field[i].name)
              return
            } else {
              value = this.field[i].value
            }
          }
        }

        select = await util.post("comprehensive", "server/getdata", {
          server: this.temp.server.server,
          key: [this.temp.field.key], //显示的字段
          lasetkey: this.temp.condition.key,//条件
          lasetvalue: value._id,
          query: this.query,
        })
        if (select !== false) {
          this.selectlist_datas = select
        }
        this.selectvalue = this.temp.value
      } else {
        var key = [this.temp.field.key]
        for (var eventfiedKey in this.temp.eventfied) {
          key.push(this.temp.eventfied[eventfiedKey])
        }
        console.log(321)
        select = await util.post("comprehensive", "server/getdata", {server: this.temp.server.server, query: this.query, key: key})
        if (select !== false) {
          this.selectlist_datas = select
        }
        this.selectvalue = this.temp.value
      }

    },
    selectdata(e) {
      if (e) {
        e[this.temp.field.key] = e.name
      }
      //关联显示需要把另外一个字段赋值
      if (JSON.stringify(this.temp.eventfied) != "{}" && e) {
        this.selectlist_datas.forEach((item) => {
          if (item._id == e._id) {
            for (var objKey in this.temp.eventfied) {
              for (var i = 0; i < this.field.length; i ++) {
                var obj = this.field[i];
                if (obj.key == objKey) {
                  obj.value = item[this.temp.eventfied[objKey]]
                }
              }
            }
          }
        })
      }
      this.$emit("selectchange", e)
    }
  }
}
</script>

<style scoped>
/deep/ .el-input__inner::placeholder {
  color: rgba(0, 0, 0, 0.685);
}
</style>



// WEBPACK FOOTER //
// src/page/module/util/dataselect.vue